import { Renderer2 } from '@angular/core';
import {PopoverOption} from "bootstrap";

export abstract class InputEditorBase<T extends Slick.SlickData> {
    protected constructor(protected readonly renderer: Renderer2, protected readonly args: Slick.Editors.EditorOptions<T>, protected readonly validator: (value: string, item: T, editor: InputEditorBase<T>) => Slick.ValidateResults, protected readonly customKeyDownHandler?: (event: KeyboardEvent, item: T, editor: InputEditorBase<T>) => boolean) {
        this.input = this.renderer.createElement('input');
        this.renderer.listen(this.input, 'keydown', this.onInputKeyDown);
        this.renderer.listen(this.input, 'focus', this.onInputFocus);
        //this.input.addEventListener('keydown', this.onInputKeyDown);
        //this.input.addEventListener('focus', this.onInputFocus);
        this.renderer.appendChild(this.args.container, this.input);
        this.focus();
    }

    protected readonly input: HTMLInputElement;

    destroy = (): void => {
        this.hideError();
        this.renderer.destroyNode(this.input);
        //this.input.removeEventLithis.inputstener('keydown', this.onInputKeyDown);
        //this.input.removeEventListener('focus', this.onInputFocus);
        //this.input.remove();
    }

    focus = (): void => {
        this.input.focus();
    }

    isValueChanged(): boolean {
        return !this.validate().valid;
    }
    //isValueChanged = (): boolean => {
    //    return this.input.value !== this.getHtmlFormattedValue(this.args.item);
    //}

    serializeValue = (): string => {
        return this.input.value;
    }

    loadValue = (item: T): void => {
        this.input.value = this.getHtmlFormattedValue(item);
    }

    abstract applyValue: (item: T, state: string) => void;

    validate = (): Slick.ValidateResults => {
        return this.validator ? this.validator(this.serializeValue(), this.args.item, this) : { valid: true, msg: null };
    }

    showError = (error: string): void => {
        this.hideError();

        const jqInput = $(this.input);
        const popoverId = jqInput
            .popover({ container: 'body', content: error, placement: 'right', trigger: 'manual'/*, boundary: jqInput.closest('.slickgrid').get()[0]*/ /*, constraints: [{ to: 'scrollParent', attachment: 'together' }]*/ } as PopoverOption)
            .popover('show')
            .attr('aria-describedby');
        $(`#${popoverId}`).addClass('popover-danger');
    }

    hideError = (): void => {
        $(this.input).popover('hide').popover('dispose');
    }

    protected abstract getHtmlFormattedValue: (item: T) => string;

    private onInputKeyDown = (event: KeyboardEvent): void => {
        if (this.customKeyDownHandler && !this.customKeyDownHandler(event, this.args.item, this)) {
            event.stopPropagation();
            return;
        }

        switch (event.key.replace('Arrow', '')) {
            case 'Up':
            case 'Down':
            case 'Left':
            case 'Right':
                event.stopPropagation();
                break;
        }
    }

    private onInputFocus = (event: Event): void => {
        setTimeout(() => this.input.select(), 0);
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/input-editor-base.ts